export default __webpack_public_path__ + "static/media/abmatrixnobg.eb3d5d55.png";